<template>
  <template v-if="detail?.state == 'SALE'">
    <SimpleSaleDetailView v-if="mode==1" :detail="detail" @showHelp1="showHelp"/>
    <ComplexSaleDetailView v-if="mode==2" @showHelp1="showHelp"/>
  </template>
  <template v-if="detail && detail?.state != 'SALE'">
    <div class="colFlex bothCenter wd100" style="height: 100vh">
      <img src="https://cdn.waityou.online/41e6a5f6-487e-0e66-1b15-8f7c0380864e.svg"
           style="width: 200px"/>
      <!--      <span class="lightText ft14 mt16">您要找的商品不存在或已下架</span>-->
    </div>
  </template>
  <img src="https://cdn.waityou.online/6b7a8a5d-4a84-d5ce-5c01-1cbc9f552ae5.svg"
       @click="$router.push('/sale/customer/order/list')"
       id="goToOrderList"
       class="sqr40 brd20" style="position: fixed;left: 0;top: 55%"/>
</template>
<script>
import SimpleSaleDetailView from "@/views/sale/SimpleSaleDetailView";
import ComplexSaleDetailView from "@/views/sale/ComplexSaleDetailView";
import api from "@/api";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";

export default {
  components: {ComplexSaleDetailView, SimpleSaleDetailView},
  data() {
    return {
      mode: 0,
      lessonId: this.$route.params.lessonId,
      detail: null,
      notfound: false,
    }
  },
  methods: {
    showHelp() {
      // let lastHelp = localStorage.getItem('LAST_HELP');
      // if (lastHelp) {
      //   return
      // }
      // localStorage.setItem('LAST_HELP', new Date().getTime())
      const driverObj = driver();
      driverObj.highlight({
        element: "#goToOrderList",
        popover: {
          title: "我的订单",
          description: "您可以在点击这里查看您的订单"
        }
      });
    }
  },
  mounted() {
    api.getSaleGood(this.lessonId)
        .then(ret => {
          this.detail = ret.good;
          if (ret.good.simpleMode) {
            this.mode = 1;
          } else {
            this.mode = 2;
          }
          setTimeout(this.showHelp, 1000)
        })
  }
}
</script>